import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Ruler, ChevronDown } from "lucide-react";
import { SIZE_CHART, SIZES } from "./data";

export const SizeChart = ({ parts }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="mt-4">
      <button
        type="button"
        data-testid="size-chart-toggle"
        onClick={() => setOpen((o) => !o)}
        className="inline-flex items-center gap-2 font-mono-d text-[10px] uppercase tracking-[0.2em] text-[#5f5e5a] hover:text-[#ff2a85] transition-colors"
      >
        <Ruler size={13} /> Size chart
        <ChevronDown size={13} className={`transition-transform duration-300 ${open ? "rotate-180" : ""}`} />
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            data-testid="size-chart"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
            className="overflow-hidden"
          >
            <div className="mt-3 space-y-4">
              {parts.map((key) => {
                const part = SIZE_CHART[key];
                return (
                  <div key={key} className="border border-[#e3e2dc] rounded-xl overflow-hidden bg-[#ffffff]">
                    <table className="w-full text-xs">
                      <thead>
                        <tr className="font-mono-d text-[9px] uppercase tracking-[0.18em] text-[#5f5e5a] bg-[#f3f2ec]">
                          <th className="text-left font-normal px-3 py-2">{part.title}</th>
                          {part.cols.map((c) => <th key={c} className="text-right font-normal px-3 py-2">{c}</th>)}
                        </tr>
                      </thead>
                      <tbody>
                        {SIZES.map((s) => (
                          <tr key={s} className="border-t border-[#e3e2dc]">
                            <td className="px-3 py-1.5 font-mono-d">{s}</td>
                            {part.rows[s].map((v, i) => <td key={i} className="px-3 py-1.5 text-right text-[#0a0a0b]">{v}"</td>)}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                );
              })}
              <p className="font-mono-d text-[9px] uppercase tracking-[0.15em] text-[#5f5e5a]">Measurements in inches · Oversized fit · Size down for a regular fit</p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
